export const GRID_VIEW_COLORS = {
    GREEN: "green",
    RED: "red",
    YELLOW: "yellow"
}